import {
  computed, ref, toRefs, onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import useFacets from './useFacets';
import { SET_CONVO_SEARCH_FILTER } from '../store/mutations';
import getMultiSelectedValues from '../utils/getMultiSelectedValues';
import useConvoAnalytics from './useConvoAnalytics';
import { IConversantionalSearchResult, IFacetValue } from '../types/convo-search.definitions'; // eslint-disable-line no-unused-vars

export default function useConvoSearch(props) {
  const { replaceSelectedValues, triggerSelectedFacetsUpdate, facetByPropery } = useFacets();
  const { fireClicks, targetRef } = useConvoAnalytics(props.experiment);

  /** @type {IConversantionalSearchResult} */
  const { searchResult } = toRefs(props);

  const store = useStore();

  const selectedValues = ref({});

  const conversationalSearchFilterRef = computed(() => {
    let convoSearchFilter;
    let facetKey;
    let selectedFacetValue;

    if (props.multiple) {
      // TODO
    } else {
      facetKey = searchResult.value?.suggestedAnswers?.name;
      selectedFacetValue = (selectedValues.value[facetKey] || [])[0];
      convoSearchFilter = `${facetKey}!${encodeURIComponent(selectedFacetValue)}`;
    }

    return convoSearchFilter;
  });

  function setConvoOptions({ conversationalSearchFilter }) {
    store.commit(SET_CONVO_SEARCH_FILTER, { conversationalSearchFilter });
  }

  function resetConvoOptions() {
    // reset conversationalSearchFilter
    setConvoOptions({
      conversationalSearchFilter: null,
    });
  }

  onBeforeUnmount(() => {
    resetConvoOptions();
  });

  /**
   * @param {string} name
   * @param {string} value
   */
  const updateSelectedValues = (name, value) => {
    selectedValues.value[name] = props.multiple ? [...(selectedValues.value[name] || []), value] : [value];
  };

  const updateFacet = (facet) => {
    if (props.multiple) {
      // TODO tiles implementation
    } else {
      setConvoOptions({
        conversationalSearchFilter: conversationalSearchFilterRef.value,
      });

      // update facet in the store and emit event
      replaceSelectedValues(facet);
      triggerSelectedFacetsUpdate();
    }
  };

  const updateFacetByType = (storeFacet, facetName) => {
    const newSelectedValues = selectedValues.value[facetName] || [];
    let facetSelectedValues = [];

    switch (storeFacet.facetType) {
    case 'MULTISELECTBUTTON':
      facetSelectedValues = getMultiSelectedValues(storeFacet, facetName, newSelectedValues);
      break;
    default:
      facetSelectedValues = [...storeFacet.selectedValues, ...newSelectedValues];
    }

    const updatedFacet = {
      ...storeFacet,
      selectedValues: facetSelectedValues,
    };

    return updatedFacet;
  };

  /**
   * even handler on tile click
   * @param {string} facetName
   * @param {IFacetValue} facetValue
   */
  const onSelect = (facetName, facetValue) => {
    fireClicks();

    updateSelectedValues(facetName, facetValue.value);
    const storeFacet = facetByPropery({
      property: 'displayName', value: facetName, deep: true,
    }) || { displayName: facetName, name: facetName, selectedValues: [] };

    const facet = updateFacetByType(storeFacet, facetName);
    updateFacet(facet);
  };

  return {
    onSelect,
    updateFacet,
    selectedValues,
    updateSelectedValues,
    conversationalSearchFilterRef,
    targetRef,
  };
}
